import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { getDomainDefaultLanguage } from './utils/languageUtils';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    supportedLngs: ['en', 'fr'],
    lng: localStorage.getItem('i18nextLng') || getDomainDefaultLanguage(),
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Available namespaces
    defaultNS: 'translation',
    ns: ['translation', 'home', 'auth', 'events', 'appointments', 'common'],
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('i18nextLng', lng);
});

export default i18n;

